import { FC } from 'react';

import { withPopupLayer } from '@gem/popups';

import {
  RouterParams,
  RouterParamsPopup,
  RouterState,
  RouterStatePopup,
} from 'APP/router/constants';
import useGetParameters from 'APP/router/hooks/useGetParameters';
import useGetState from 'APP/router/hooks/useGetState';

import { NewUsersPopup } from './Popups/NewUsersPopup/NewUsersPopup';
import ShareMessageTo from './Popups/ShareMessageTo';
import Sticker from './Popups/Sticker';

const popups: Record<string, FC> = {
  [RouterStatePopup.shareMessageTo]: withPopupLayer(ShareMessageTo),
  [RouterStatePopup.newUsers]: withPopupLayer(NewUsersPopup),
  [RouterStatePopup.sticker]: withPopupLayer(Sticker),
};

export const GetParametersManager: FC = () => {
  const popupNames = useGetParameters(RouterParams.popup);
  const popupNameState = useGetState<string>(RouterState.popup);

  if (popupNameState) {
    popupNames.push(popupNameState);
  }

  return (
    <>
      {popupNames.map((name: RouterParamsPopup) => {
        const Component = popups[name];

        if (!Component) {
          return null;
        }

        return <Component key={name} />;
      })}
    </>
  );
};
